import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Form,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  ModalHeader,
  Button,
  Label,
  FormFeedback,
  Row,
  Col,
  InputGroup,
} from "reactstrap"
import * as Yup from "yup"

import { useFormik } from "formik"
import toast, { Toaster } from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { useLocation } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import breadcrumbs from "common/Breadcrumbs"
import UserTable from "./UserTable"
import DeleteModel from "common/deleteModel/deleteModel"
import { exportDataExcel } from "components/Common/ExportData"

function UserList() {
  document.title = `Users | Raja Rani Couture`
  let { pathname } = useLocation()
  const { deleteApi, getApi, postApi, putApi } = useApi()
  // useStates
  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [editData, setEditData] = useState(null)
  const [tableData, setTableData] = useState([])
  const [userId, setUserId] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [screenLoad, setScreenLoad] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [totalRecords, setTotalRecords] = useState(0)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)
  const [displayStart, setDisplayStart] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [gender, setGender] = useState("1")
  const [passwordShow, setPasswordShow] = useState(false)
  const [isActive, setIsActive] = useState(false)

  // filter data for user
  const filterData = textFilter => {
    setSearchText(textFilter == undefined ? '' : textFilter)
  }

  const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
    setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
    setSearchText(serchValue == undefined ? "" : serchValue)
    setRowsPerPage(pageSize)
  }

  // user list api
  const userListApi = () => {
    setIsLoading(true)
    setScreenLoad(true)
    postApi("User/user-list", {
      IsActive: isActive ? false : true,
      displayStart: displayStart,
      pageSize: rowsPerPage,
      searchText: searchText.trim(),
      sortColumn: "",
      sortOrder: "asc",
    }).then(({ data, status }) => {
      if (status === 200) {
        setTableData(data.UserList)
        setTotalRecords(data.TotalRecords)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setIsLoading(false)
      setScreenLoad(false)
    })
  }

  // user list api useEffect
  useEffect(() => {
    userListApi()
  }, [rowsPerPage, searchText, displayStart, isActive])

  // Delete user handler
  const handleDelete = userId => {
    setScreenLoad(true)
    if (userId) {
      DeleteModel.confirmDeleteInquiry({
        title: "Are you sure? ",
        text: "You want to delete this user permanently? ",
        isMobile,
      }).then(response => {
        if (response == true) {
          deleteApi(`User/delete-user?id=${userId}`).then(
            async ({ data, status }) => {
              if (status === 200) {
                const updatedArray = tableData
                  .map(obj => (obj.Id !== userId ? obj : null))
                  .filter(Boolean)
                setTableData(updatedArray)
                toast.success("Sucessfully deleted", {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                // ErrorModel.errormodel({
                //   title: "Verify Color",
                //   text: data,
                // })
              }
              setScreenLoad(false)
            }
          )
        } else {
          setScreenLoad(false)
        }
      })
    }
  }

  // cancle handler
  const handleCancle = () => {
    toggle()
  }

  // Update user handler
  const handleEditUser = userData => {
    if (userData) {
      getApi(`User/user-details?id=${userData.Id}`).then(({ data, status }) => {
        if (status === 200) {
          setEditData(data)
          setGender(String(data.Gender))
        } else {
          toast.error(data, {
            style: {
              fontSize: "15px",
            },
          })
        }
      })
      setUserId(userData.Id)
      setIsEdit(true)
      setModal(!modal)
    }
  }

  // Create user handler
  const handleUserClick = () => {
    setIsEdit(false)
    toggle()
  }

  // Colors Validations
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      Fullname: isEdit ? editData?.FullName : "",
      Username: isEdit ? editData?.Username : "",
      Password: isEdit ? editData?.Password : "",
      ContactNo: isEdit ? editData?.ContactNo : "",
      Address: isEdit ? editData?.Address : "",
    },
    validationSchema: Yup.object({
      Fullname: Yup.string().required("The full name is required"),
      Username: Yup.string().required("The username is required"),
      ContactNo: Yup.string()
        .required("The contact number is required.")
        .matches(/^[0-9]{10}$/, "Contact number must be a 10-digit number"),
      Password: !isEdit && Yup.string().required("The password is required"),
      Address: Yup.string().required("The address is required"),
    }),
    onSubmit: values => {
      setformSumitLoading(true)
      if (values) {
        isEdit
          ? putApi("User/update-user", {
            id: userId,
            Fullname: values.Fullname,
            Username: values.Username,
            ContactNo: values.ContactNo,
            Address: values.Address,
            Gender: parseInt(gender)
          }).then(({ data, status }) => {
            setformSumitLoading(false)
            if (status == 400) {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
            } else {
              toast.success("Sucessfully updated", {
                style: {
                  fontSize: "15px",
                },
              })
              setformSumitLoading(false)
              toggle()
              userListApi()
              validation.handleReset()
            }
          })
          : postApi("User/create-user", {
            Fullname: values.Fullname,
            Username: values.Username,
            ContactNo: values.ContactNo,
            password: values.Password,
            Address: values.Address,
            Gender: parseInt(gender)
          }).then(({ data, status }) => {
            setformSumitLoading(false)
            if (status == 400) {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
            } else {
              toast.success("Sucessfully created", {
                style: {
                  fontSize: "15px",
                },
              })
              toggle()
              userListApi()
              validation.handleReset()
            }
          })
      }
    },
  })

  // popup box handler
  const toggle = () => {
    setModal(!modal)
    validation.handleReset()
  }

  const passwordValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      NewPassword: "",
      ConfirmPassword: "",
    },
    validationSchema: Yup.object({
      NewPassword: Yup.string().required("The new password is required"),
      ConfirmPassword: Yup.string()
        .required("The confirm password is required")
        .oneOf([Yup.ref("NewPassword")], "Passwords must match"),
    }),
    onSubmit: values => {
      if (values) {
        setScreenLoad(true)
        DeleteModel.confirmDeleteInquiry({
          title: "Are you sure? ",
          text: "You want to update password this user? ",
          isMobile,
        }).then(response => {
          if (response == true) {
            putApi("User/update-password", {
              userId: userId,
              newPassword: values.ConfirmPassword,
            }).then(({ data, status }) => {
              if (status == 400) {
                toast.error(data, {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                toast.success("successfully updated", {
                  style: {
                    fontSize: "15px",
                  },
                })
                setModal1(false)
              }
              setScreenLoad(false)
            })
          } else {
            setScreenLoad(false)
            setModal1(true)
          }
        })
      }
    },
  })

  const handleSwitch = async (id, value) => {
    setScreenLoad(true)
    activeInactiveUserApi(id)
  }

  const activeInactiveUserApi = (id) => {
    DeleteModel.confirmDeleteInquiry({
      title: "Are you sure ?",
      text: "You want to Inactive this user permanently ?",
      isMobile,
    }).then(response => {
      if (response == true) {
        putApi(`User/active-user`,
          {
            id: parseInt(id),
          }).then(({ data, status }) => {
            if (status === 200) {
              toast.success("Sucessfully Changed", {
                style: {
                  fontSize: "15px",
                },
              })
              setScreenLoad(false)
            } else {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
              setScreenLoad(false)
            }
            userListApi()
            setScreenLoad(false)
          })
      } else {
        userListApi()
        setScreenLoad(false)
      }
    })
  }

  const handleChangePassword = userId => {
    if (userId) {
      setUserId(userId)
    }
    setModal1(!modal1)
  }

  // table headers & accessor
  const columns = useMemo(
    () => [
      {
        Header: "Username",
        accessor: "Username",
        width: "13%"
      },
      {
        Header: "Full Name",
        accessor: "FullName",
        width: "18%"
      },
      {
        Header: "Contact#",
        accessor: "ContactNo",
        width: "12%"
      },
      {
        Header: "Gender",
        accessor: "Gender",
        width: "6%",
        Cell: ({ row }) => {
          return (
            <div>{row.original.Gender == 1 ? "Male" : "Female"}</div>
          )

        },
      },
      {
        Header: "Address",
        accessor: "Address",
        Cell: ({ row }) => (
          <p title={`${row.original.Address}`} className=" mb-0" style={{ textWrap: "wrap" }}>
            {row.original?.Address == null
              ? "N/A"
              : row.original?.Address}
          </p>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Is Active
          </div>
        ),
        width: "6%",
        accessor: "IsActive",
        disableSorting: true,
        Cell: ({ row }) => (
          <FormGroup switch className="d-flex justify-content-center">
            <Input
              disabled={!row.original.IsActive}
              id={`IsActive_${row.original.Id}`}
              type="switch"
              defaultChecked={row.original.IsActive}
              onClick={e => {
                handleSwitch(row.original.Id, e.target.checked)
              }}
            />
          </FormGroup>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "8%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">

              {JSON.parse(localStorage.getItem("authUser")).RoleName == "Admin" &&
                <li className="mytooltip">
                  <i
                    className=" fs-6 fas fa-unlock-alt "
                    style={{ color: "#90499c", cursor: "pointer" }}
                    id={`changepasswordtooltip${row.original.Id}`}
                    onClick={() => handleChangePassword(row.original.Id)}
                  ></i>
                  <span className="mytext">Change Password</span>
                </li>
              }

              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit"
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handleEditUser(row.original)}
                ></i>
                <span className="mytext">Edit</span>
              </li>

              <li className="mytooltip">
                <i
                  className="fs-6 fas fa-trash-alt btn-delete"
                  id={`deletetooltip${row.original.Id}`}
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <span className="mytext">Delete</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  const handleKeyPress = event => {
    const charCode = event.which || event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };

  function writeDataToExcel() {
    setIsLoading(true)
    let header = ["Username", "Full Name", "ContactNo", "Gender", "Address"];
    const mainTitle = "Users";
    const widthObj = [{
      Key: "A",
      Value: 15,
    },
    {
      Key: "B",
      Value: 18,
    },
    {
      Key: "C",
      Value: 12,
    },
    {
      Key: "D",
      Value: 10,
    },
    {
      Key: "E",
      Value: 30,
    },
    ]
    const extention = "Users.xlsx"
    let excelSheetData = []

    postApi("User/user-list", {
      displayStart: displayStart,
      pageSize: 100000,
      searchText: searchText.trim(),
      sortColumn: "",
      sortOrder: "asc",
    }).then(({ data, status }) => {
      if (status === 200) {
        for (let index = 0; index < data?.UserList.length; index++) {
          let dataObj = {
            Username: data?.UserList[index].Username,
            FullName: data?.UserList[index].FullName,
            ContactNo: data?.UserList[index].ContactNo,
            Gender: data?.UserList[index].Gender == 1 ? "Male" : "Female",
            Address: data?.UserList[index].Address,
          }
          excelSheetData.push(dataObj)
        }
        var fields = Object.keys(excelSheetData[0]);
        var sheetData = excelSheetData.map(function (row) {
          return fields.map(function (fieldName) {
            return row[fieldName];
          });
        });
        setIsLoading(false)
        sheetData.unshift(header);
        exportDataExcel(sheetData, mainTitle, widthObj, extention)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setIsLoading(false)
      setScreenLoad(false)
    })

    setIsLoading(false)

  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screenLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].parent}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
          link={breadcrumbs[pathname].parentLink}
        />
        <Card>
          <CardBody>
            <UserTable
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              isAddUserList={true}
              handleUserClick={handleUserClick}
              customPageSize={10}
              className="custom-header-css"
              filterData={filterData}
              isLoading={isLoading}
              TotalRecords={totalRecords}
              pagePerSize={pagePerSize}
              writeDataToExcel={writeDataToExcel}
              setIsActive={setIsActive}
              isActive={isActive}
            />

            <Modal
              isOpen={modal}
              toggle={toggle}
              centered={true}
              size="small"
              style={{ width: !isMobile ? "500px" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                  {isEdit ? "Update User" : "Create User"}
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      validation.handleReset()
                      return false
                    }}
                  >
                    <Row>
                      <FormGroup className="mb-2">
                        <Label htmlFor="validationCustom03" className="required">
                          Full Name
                        </Label>
                        <Input
                          name="Fullname"
                          placeholder="full name"
                          type="text"
                          className="form-control-sm"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.Fullname || ""}
                          invalid={
                            validation.touched.Fullname && validation.errors.Fullname
                              ? true
                              : false
                          }
                        />
                        {validation.touched.Fullname && validation.errors.Fullname ? (
                          <FormFeedback type="invalid">
                            {validation.errors.Fullname}
                          </FormFeedback>
                        ) : null}
                      </FormGroup>
                    </Row>
                    <Row>

                      <Col md={isEdit ? 12 : 6}>
                        <FormGroup className="mb-2">
                          <Label htmlFor="validationCustom03" className="required">
                            Username
                          </Label>
                          <Input
                            name="Username"
                            placeholder="Username"
                            type="text"
                            className="form-control-sm"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.Username || ""}
                            invalid={
                              validation.touched.Username && validation.errors.Username
                                ? true
                                : false
                            }
                          />
                          {validation.touched.Username && validation.errors.Username ? (
                            <FormFeedback type="invalid">
                              {validation.errors.Username}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      {!isEdit &&
                        <Col md={6}>
                          <FormGroup className="mb-2">
                            <Label htmlFor="validationCustom03" className="required">
                              Password
                            </Label>
                            <Input
                              name="Password"
                              placeholder="Password"
                              type="text"
                              className="form-control-sm"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.Password || ""}
                              invalid={
                                validation.touched.Password && validation.errors.Password
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.Password && validation.errors.Password ? (
                              <FormFeedback type="invalid">
                                {validation.errors.Password}
                              </FormFeedback>
                            ) : null}
                          </FormGroup>
                        </Col>
                      }
                    </Row>
                    <Row>
                      <Col md={4}>
                        <FormGroup className="mb-2">
                          <Label htmlFor="validationCustom03" className="required">
                            Contact No.
                          </Label>
                          <Input
                            name="ContactNo"
                            placeholder="Phone Number"
                            type="text"
                            maxLength="10"
                            className="form-control-sm"
                            onKeyPress={handleKeyPress}
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.ContactNo || ""}
                            invalid={
                              validation.touched.ContactNo && validation.errors.ContactNo
                                ? true
                                : false
                            }
                          />
                          {validation.touched.ContactNo && validation.errors.ContactNo ? (
                            <FormFeedback type="invalid">
                              {validation.errors.ContactNo}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <div style={{ marginTop: "35px" }}>
                          <div className=" d-flex gap-2">
                            <FormGroup>
                              <Input
                                type="radio"
                                value="1"
                                id="male"
                                // name="gender"
                                className="form-check-input"
                                checked={gender === "1"}
                                onClick={() => { setGender("1") }}
                              />
                            </FormGroup>
                            <Label className="form-check-label font-size-13" htmlFor="male">
                              Male
                            </Label>
                            <FormGroup>
                              <Input
                                type="radio"
                                value="2"
                                id="female"
                                // name="gender"
                                className="form-check-input"
                                checked={gender === "2"}
                                onClick={() => { setGender("2") }}
                              />
                            </FormGroup>
                            <Label className="form-check-label font-size-13" htmlFor="female">
                              Female
                            </Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <FormGroup className="mb-2">
                          <Label htmlFor="" className="required">
                            Address
                          </Label>
                          <Input
                            name="Address"
                            placeholder="Enter address here"
                            type="textarea"
                            className="form-control-sm"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.Address}
                            invalid={
                              validation.touched.Address && validation.errors.Address
                                ? true
                                : false
                            }
                          />
                          {validation.touched.Address && validation.errors.Address ? (
                            <FormFeedback type="invalid">
                              {validation.errors.Address}
                            </FormFeedback>
                          ) : null}
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className="text-end">
                      {isEdit ? (
                        <Button
                          user="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          onClick={handleCancle}
                        >
                          Cancle
                        </Button>
                      ) : (
                        <Button
                          user="secondary"
                          className="btn btn-primary me-2 btn-sm "
                          type="reset"
                        >
                          Reset
                        </Button>
                      )}
                      {formSumitLoading ? (
                        <button
                          type="button"
                          className="btn btn-primary btn-sm"
                          color="secondary"
                        >
                          <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                          Loading
                        </button>
                      ) : (
                        <Button
                          user="primary"
                          className="btn btn-primary btn-sm "
                          type="submit"
                          color="primary"
                        >
                          Submit
                        </Button>
                      )}
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>

            <Modal
              isOpen={modal1}
              toggle={() => setModal1(!modal1)}
              centered={true}
              size="small"
              style={{ width: !isMobile ? "350px" : "" }}
            >
              <div className="modal-content">
                <ModalHeader toggle={() => setModal1(!modal1)} tag="h5">
                  Change Password
                </ModalHeader>
                <ModalBody>
                  <Form
                    onSubmit={e => {
                      e.preventDefault()
                      passwordValidation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault
                      passwordValidation.handleReset()
                      return false
                    }}
                  >
                    <FormGroup className="mb-2">
                      <Label htmlFor="validationCustom03" className="required">
                        New Password
                      </Label>
                      <Input
                        name="NewPassword"
                        placeholder="New Password"
                        type="password"
                        className="form-control-sm"
                        onChange={passwordValidation.handleChange}
                        onBlur={passwordValidation.handleBlur}
                        value={passwordValidation.values.NewPassword || ""}
                        invalid={
                          passwordValidation.touched.NewPassword &&
                            passwordValidation.errors.NewPassword
                            ? true
                            : false
                        }
                      />
                      {passwordValidation.touched.NewPassword &&
                        passwordValidation.errors.NewPassword ? (
                        <FormFeedback type="invalid">
                          {passwordValidation.errors.NewPassword}
                        </FormFeedback>
                      ) : null}
                    </FormGroup>
                    <Label htmlFor="validationCustom03" className="required">
                      Confirm Password
                    </Label>
                    <InputGroup className="mb-2">
                      <Input
                        className="form-control-sm"
                        name="ConfirmPassword"
                        value={passwordValidation.values.ConfirmPassword || ""}
                        type={passwordShow ? "text" : "password"}
                        placeholder="Confirm Password"
                        onChange={passwordValidation.handleChange}
                        onBlur={passwordValidation.handleBlur}
                        invalid={
                          passwordValidation.touched.ConfirmPassword &&
                          !!passwordValidation.errors.ConfirmPassword
                        }
                      />
                      <Button
                        onClick={() => setPasswordShow(!passwordShow)}
                        className="btn btn-sm"
                        style={{ border: "1px solid #ced4da" }}
                        color="light"
                      >
                        {passwordShow ? (
                          <i className="mdi mdi-eye-outline" />
                        ) : (
                          <i className="mdi mdi-eye-off-outline" />
                        )}
                      </Button>
                      {passwordValidation.touched.ConfirmPassword &&
                        passwordValidation.errors.ConfirmPassword ? (
                        <FormFeedback type="invalid">
                          {passwordValidation.errors.ConfirmPassword}
                        </FormFeedback>
                      ) : null}
                    </InputGroup>

                    <div className="text-end">
                      <>
                        <Button
                          color="primary"
                          className="btn btn-primary btn-sm "
                          type="submit"
                        >
                          Submit
                        </Button>
                      </>
                    </div>
                  </Form>
                </ModalBody>
              </div>
            </Modal>


          </CardBody>
        </Card>
      </div>
    </div>
  )
}
UserList.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
  onFilterChange: PropTypes.func,
}

export default UserList
